import type UserAgentInfo from 'js/lib/useragent';

/**
 * Replaced by the bundler with actual values at build time (see browserSupportVersions.ts).
 */
declare const __BROWSER_SUPPORT_MIN_VERSIONS__: {
  chrome: number;
  edge: number;
  firefox: number;
  safari: number;
};

type BrowserSupportKey = keyof typeof __BROWSER_SUPPORT_MIN_VERSIONS__;

const UA_NAME_TO_BROWSER_SUPPORT_KEY: Partial<Record<string, BrowserSupportKey>> = {
  Chrome: 'chrome',
  Edge: 'edge',
  Firefox: 'firefox',
  Safari: 'safari',
};

function parseMajor(version: string | undefined): number | null {
  if (!version) return null;
  const major = parseInt(version, 10);
  return Number.isFinite(major) ? major : null;
}

/**
 * Returns true if the given user agent is considered unsupported based on the minimum
 * per-browser versions defined in __BROWSER_SUPPORT_MIN_VERSIONS__.
 */
export function isUnsupportedBrowser(ua: UserAgentInfo | undefined | null): boolean {
  if (!ua) return false;
  if (ua.isRobot || ua.isPrerender || ua.isCourseraMobileApp) return false;
  if (ua.browser.name === 'IE') return true;

  // __BROWSER_SUPPORT_MIN_VERSIONS__ is only defined by the webpack DefinePlugin
  // (see browserSupportVersions.ts) -- it's absent under snowpack, which has no
  // equivalent build-time substitution for this identifier.
  if (typeof __BROWSER_SUPPORT_MIN_VERSIONS__ === 'undefined') return false;

  const key = UA_NAME_TO_BROWSER_SUPPORT_KEY[ua.browser.name];
  if (!key) return false;

  const min = __BROWSER_SUPPORT_MIN_VERSIONS__[key];
  const major = parseMajor(ua.browser.version);
  if (major === null) return false;

  return major < min;
}
